export default "__VITE_ASSET__DISE9fY7__"